import {FC, useEffect, useRef, useState} from "react";
import {Accordion} from "react-bootstrap";
import {
  ConfirmModelDialogBox,
  DeleteTransaction,
  ErrorValidationBox,
  GenericModelPopupPdfReportViewer,
  LoadingBox,
  RegisterTransaction,
  ToastBox,
  TransactionList,
} from "../..";
import {
  ActionTypeEnum,
  ComponentActionTypeEnum,
  DailyTransactionTypeEnum,
  HasFormIdModel,
  PrintTypeEnum,
  RequestActionModel,
  RowStateEnum,
  ToastModel,
  TransactionDetailResponseModel,
  ValidateTransactionModeEnum,
  ValidationErrorModel,
} from "../../../models";
import {
  deleteTransaction,
  getTransactionDetail,
  getTransactionDetailForRefund, validateTransactionEligibilityForPayment,
} from "../../../serviceBroker/transactionApiServiceBroker";
import {generateGuid, getLabelName, scrollToDocumentTop,} from "../../../utils";
import {
  clearTransactionDataForRefund,
  prepareAndValidateTransactionAsSourceRequest,
  transactionDetailInitialValue,
} from "../common/businessLogic/transactionBl";
import {useNavigate, useSearchParams} from "react-router-dom";
import {RoutePageConfigurations} from "../../../configuration";
import {
  validateGetRefundRequestDetails,
  validateTransactionEligibility
} from "../common/businessLogic/validationBl";
import {extractTransactionParams} from "../common/businessLogic/transactionUtilsBl";
import {useGenericSystemConfigurations, useSystemConfigurations} from "../../../hooks";


// private decimal GetCorrectTaxPercentage(decimal SalesPrice , decimal PriceCost)
// {
//   // The Actual price that tax will be calculated on
//   decimal pricedToCalcTax = SalesPrice - PriceCost;
//   // Get priceof Actual with tax
//   decimal priceAfterTax = GetPriceWithTax(pricedToCalcTax, CompanySetting.Instance.DefaultTaxPercentage.GetValueOrDefault());
//   // Get The Tax value to get the correct percentage
//   decimal taxValue = priceAfterTax - pricedToCalcTax;
//   decimal taxPercentge =  CalculatePercentage(taxValue, SalesPrice);
//   return taxPercentge;
// }
// public static decimal GetPriceWithTax(decimal value, decimal TaxPercentage )
// {
//   return ((value ) * TaxPercentage) / 100 + (value );
// }
// public static decimal CalculatePercentage(decimal firstValue, decimal secondValue)
// {
//   if (secondValue == 0)
//     return 0;
//
//   return (firstValue / secondValue) * 100;
// }

interface TransactionMainComponentProps extends HasFormIdModel {
  transactionType: DailyTransactionTypeEnum;
}

export const TransactionMainComponent: FC<TransactionMainComponentProps> = ({
  transactionType,
  formId,
}) => {
  //#region state
  const registerTransactionRef = useRef<any>(null); // Ref for the child component
  const [key, setKey] = useState(0);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [printTransactionId, setPrintTransactionId] = useState(0);
  const [showPrintoutPdfModel, setShowPrintoutPdfModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [componentActionType, setComponentActionType] =
    useState<ComponentActionTypeEnum>(ComponentActionTypeEnum.None);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const [object, setObject] = useState<TransactionDetailResponseModel | null>(
    null
  );
  const [validationErrors, setValidationErrors] = useState<
    ValidationErrorModel[]
  >([]);
  const [toastModel, setToastModel] = useState<ToastModel>({
    show: false,
    variant: "success",
  });
  const{userConfiguration,isTransactionLoaded}=useSystemConfigurations(setLoading,transactionType)
  //#endregion
  //#region useEffect
  useEffect(() => {
    const fillData = async () => {
      const transactionParams = extractTransactionParams(searchParams);
      if (transactionParams) {
       await handleAction(transactionParams);
      }
    };
    fillData().then(() => {});
  }, [searchParams]);
  //#endregion
  //#region function
  const handleAction = async (request: RequestActionModel) => {
    // setObject(null);
    switch (request.action) {
      case ActionTypeEnum.AddSuccess:
      case ActionTypeEnum.DeleteSuccess:
      case ActionTypeEnum.SaveSuccess:
      case ActionTypeEnum.Success:
        scrollToDocumentTop();
        setObject({ ...transactionDetailInitialValue() });
        setToastModel({ ...toastModel, show: true });
        setIsRefresh(true);
        setComponentActionType(ComponentActionTypeEnum.Reset);
        setValidationErrors([]);
        setShowDeleteModel(false);
        break;
      case ActionTypeEnum.Delete:
        setLoading(true);
        const deleteTransactionsResponse = await deleteTransaction(
          request.request
        );
        if (
          deleteTransactionsResponse.Errors !== null &&
          deleteTransactionsResponse.Errors !== undefined &&
          deleteTransactionsResponse.Errors.length !== 0
        ) {
          setValidationErrors(deleteTransactionsResponse.Errors);
          //scrollToTop(validationMessageRef);
          scrollToDocumentTop();
        } else {
         await  handleAction({action: ActionTypeEnum.DeleteSuccess});
          // setShowDeleteModel(false);
          // setIsRefresh(true);
        }
        setLoading(false);
        break;
      case ActionTypeEnum.Add:
        setObject(null);
        break;
      case ActionTypeEnum.View:
        setLoading(true);
        setValidationErrors([]);
        scrollToDocumentTop();
        const viewRecord = await getTransactionDetail(request.request.id!);
        if (viewRecord?.Result != null) {
          viewRecord.Result.rowState = RowStateEnum.View;
          viewRecord.Result.TransactionDetaillist.forEach((row) => {
            row.rowState = RowStateEnum.View;
            row.rowKey = generateGuid();
          })}
          setObject(viewRecord?.Result??null);
          setComponentActionType(ComponentActionTypeEnum.Edit);
          setLoading(false);
          break;
      case ActionTypeEnum.Update:
      case ActionTypeEnum.ModifyStart:
        setLoading(true);
        setValidationErrors([]);
        scrollToDocumentTop();
        // const record=await  prepareAndValidateRequest({transactionId: request.request.id,transactionType,actionType: request.action,beneficiaryList: []});
        // setValidationErrors(record?.Errors||[]);
        // setObject(record?.Result||transactionDetailInitialValue());
        const record = await getTransactionDetail(request.request.id!);
        if (record?.Result != null) {
          record.Result.rowState = RowStateEnum.Update;
          record.Result.TransactionDetaillist.forEach((row) => {
            row.rowState = RowStateEnum.Update;
            row.rowKey = generateGuid();
          })
          const validateTransactionEligibilityErrors=await validateTransactionEligibility({transactionId:record.Result.ID,creationDate:record.Result.Date,totalTax:record.Result.TotalTax,mode:ValidateTransactionModeEnum.Modify});
          if(validateTransactionEligibilityErrors?.length!==0){
            setValidationErrors(validateTransactionEligibilityErrors);
            setLoading(false);
            return;
          }
        }
        setObject(record?.Result??null);
        setComponentActionType(ComponentActionTypeEnum.Edit);
        setLoading(false);
        break;
      case ActionTypeEnum.TransactionRefundIInitialization:
        const refundInitParamUrl: string = `bImDq=${request.request.id!}&ojXNQ=${generateGuid()}`;
        switch (transactionType) {
          case DailyTransactionTypeEnum.SalesInvoice:
          case DailyTransactionTypeEnum.POSSales:
          case DailyTransactionTypeEnum.POSSalesRefund:
          case DailyTransactionTypeEnum.POSRestaurant:
          case DailyTransactionTypeEnum.Reserve_Restaurant_Bill:
          case DailyTransactionTypeEnum.ReturnPOSRestaurant:
            navigate(`${RoutePageConfigurations.sales.salesRefundPage}?${refundInitParamUrl}`);
            //navigate(`/transactions/sales/refund?${refundInitParamUrl}`);
            setKey((prevKey) => prevKey + 1);
            break;
          case DailyTransactionTypeEnum.PurchasesInvoice:
            navigate(`${RoutePageConfigurations.purchases.purchasesRefundPage}?${refundInitParamUrl}`);
            //navigate(`/transactions/purchases/refund?${refundInitParamUrl}`)
            setKey((prevKey) => prevKey + 1);
            break;
        }
        break;
      case ActionTypeEnum.TransactionRefund:
        setLoading(true);
        setValidationErrors([]);
        scrollToDocumentTop();
        let recordForReturn = await getTransactionDetailForRefund(request.id!);
        const  refundErrors: ValidationErrorModel[] = await validateGetRefundRequestDetails(recordForReturn);
        if (
            refundErrors.length !== 0
        ) {
          setValidationErrors(refundErrors);
          setLoading(false);
          return;
        }
          const obj=await clearTransactionDataForRefund(recordForReturn?.Result || transactionDetailInitialValue())
          setObject(obj);
          setComponentActionType(ComponentActionTypeEnum.Refund);
        setLoading(false);
        break;
      case ActionTypeEnum.IssueSaleTransactionFromSalePriceInitialization:
        const reSaleTransInitParamUrl: string = `rUHaU=${request.request.id!}&ojXNQ=${generateGuid()}`;
        navigate(`${RoutePageConfigurations.sales.salesInvoicePage}?${reSaleTransInitParamUrl}`);
        setKey((prevKey) => prevKey + 1);
        break;
      case ActionTypeEnum.IssueSaleTransactionFromSalePrice:
        setLoading(true);
        setValidationErrors([]);
        scrollToDocumentTop();
        const [recordForSale, errorsForSale]= await prepareAndValidateTransactionAsSourceRequest({
          transactionId: request.id!,
          actionType: request.action,
          transactionType: transactionType,
        });
        if(errorsForSale?.length!=0) {
          setValidationErrors(errorsForSale);
          setObject(null)
        }else {
          // if (registerTransactionRef.current) {
          //  await  registerTransactionRef.current.fillData(recordForSale); // Call the child method
          // }
           setObject(recordForSale);
           setComponentActionType(ComponentActionTypeEnum.IssueTransactionFromSource);
        }
        setLoading(false);
        break;
      case ActionTypeEnum.InitializeCustomerPayment:
        setLoading(true);
        setValidationErrors([]);
        scrollToDocumentTop();
        const paymentEligibilityValidationResponse =  await validateTransactionEligibilityForPayment(Number(request.request.id!));
        if (paymentEligibilityValidationResponse?.Errors && paymentEligibilityValidationResponse.Errors.length > 0) {
          setValidationErrors(paymentEligibilityValidationResponse.Errors);
          return;
        }
        const payTransactionInitParamUrl: string = `K8VaI=${request.request.id!}&ojXNQ=${generateGuid()}`;
        navigate(`${RoutePageConfigurations.customers.customerPaymentPage}?${payTransactionInitParamUrl}`,{state:paymentEligibilityValidationResponse.Result});
        setLoading(false);
        break;
      case ActionTypeEnum.DeleteStart:
        setObject(request.request);
        setShowDeleteModel(true);
        break;
      case ActionTypeEnum.DeleteFailed:
        setValidationErrors(request.request);
        setShowDeleteModel(false);
        scrollToDocumentTop();
        break;
      case ActionTypeEnum.DeleteReset:
        setValidationErrors([]);
        setObject(null);
        setShowDeleteModel(false);
        break;
      case ActionTypeEnum.ClearError:
        setValidationErrors([]);
        break;
      case ActionTypeEnum.Clear:
        scrollToDocumentTop();
        setObject({ ...transactionDetailInitialValue() });
        setComponentActionType(ComponentActionTypeEnum.Reset);
        setValidationErrors([]);
        break;
      case ActionTypeEnum.RaiseError:
        scrollToDocumentTop();
        setValidationErrors(request.request);
        break;
      case ActionTypeEnum.AddPartialCustomerStart:
        break;
      case ActionTypeEnum.PrintPdf:
        setPrintTransactionId(request?.request?.id || 0);
        setShowPrintoutPdfModel(true);
        break;
    }
  };
  //#endregion
  //#region html
  return (
    <div key={key}>
      {/*<div ref={validationMessageRef} />*/}
      {loading || !isTransactionLoaded && <LoadingBox />}
      {showPrintoutPdfModel && (
        <GenericModelPopupPdfReportViewer
          keys={[{ key: "transactionId", value: printTransactionId }]}
          type={PrintTypeEnum.Invoice}
          onCloseEvent={() => {
            setShowPrintoutPdfModel(false);
          }}
        />
      )}
      {<ErrorValidationBox errors={validationErrors} />}
      {toastModel.show && (
        <ToastBox
          isShown={toastModel.show}
          header={toastModel.header}
          body={toastModel.body}
          variant={toastModel.variant}
          delayDuration={toastModel.delayDuration}
          onCloseEvent={() => {
            setToastModel({ ...toastModel, show: false });
          }}
        />
      )}
      <RegisterTransaction
        ref={registerTransactionRef}
        transactionType={transactionType}
        request={object}
        setActionType={setComponentActionType}
        actionType={componentActionType}
        onActionEvent={(o: RequestActionModel) => {
          handleAction(o).then(() => {});
        }}
        formId={formId}
      />
      <ConfirmModelDialogBox
        isModelVisible={showDeleteModel}
        onCloseEvent={() => {
          setShowDeleteModel(false);
        }}
      >
        <DeleteTransaction
          onActionEvent={handleAction}
          //@ts-ignore
          request={object}
        />
      </ConfirmModelDialogBox>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{getLabelName("Previous Data")}</Accordion.Header>
          <Accordion.Body className="TUEFO-header">
            <TransactionList
              transactionType={transactionType}
              onActionEvent={(o: RequestActionModel) => {
                handleAction(o).then(() => {});
              }}
              setIsRefresh={setIsRefresh}
              isRefresh={isRefresh}
              formId={formId}
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
  //#endregion
};
